import { RouteObject } from 'react-router-dom';
import ListArenaResponsive from "../components/ResponsiveWrapper/Arena/ListArenaResponsive";
import ListArenas, { loader as ListArenasLoader } from "../pages/ListArenas";
import SingleArenaResponsive from "../components/ResponsiveWrapper/Arena/SingleArenaResponsive";
import Arena, { loader as SingleArenaLoader } from "../pages/Arena";

export const arenasRoutes: RouteObject = {
  path: 'arenas',
  children: [
    {
      index: true,
      element: <ListArenaResponsive />,
      loader: ListArenasLoader
    },
    {
      path: ':id',
      element: <SingleArenaResponsive />,
      loader: SingleArenaLoader
    },
  ]
};
